module.exports = __webpack_public_path__ + "img/target.a4b0783a.svg";